import React, { ReactNode, useEffect } from 'react';

import { createPortal } from 'react-dom';

import './CommonModal.scss';

type ModalType = {
  showModal: boolean;
  closeModal: () => void;
  children: ReactNode;
  escToClose?: boolean;
};

export const CommonModal = ({
  showModal,
  closeModal,
  children,
  escToClose,
}: ModalType) => {
  useEffect(() => {
    const keyListener = (e: KeyboardEvent) => {
      if (escToClose && e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', keyListener);

    return () => window.removeEventListener('keydown', keyListener);
  }, []);

  if (!showModal) return null;

  return createPortal(
    <>
      <div className="box">
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div className="container" onClick={closeModal} />
      </div>
      <div className="box modal-box">{children}</div>
    </>,
    document.body,
  );
};
